export const getConfirmation = state => state.notification.get('confirmation');
export const getNotification = state => state.notification.get('notification');
